import { SliderState, Transition, IContainerSize, ICoords, IMovingState } from './types';
import { getCurrentSlide, getXOffset } from './utils';
import { getYOffsetHanlder } from './utils/get_y_offset';

export function otherwiseChangingSlides(node: HTMLElement, slideIndex: number) {
  return (state: SliderState) => {
    const slides = state.slides.map((slide, index) => {
      return !slide.size && index === slideIndex
        ? {
            ...slide,
            size: { width: node.clientWidth, height: node.clientHeight },
          }
        : slide;
    });

    return { slides };
  };
}

export function makeTransitionSetState(
  getTransition: (state: SliderState, containerSize?: IContainerSize) => Transition,
  containerSize?: IContainerSize,
) {
  return (state: SliderState) => {
    if (state.action === 'transition') {
      return undefined;
    }

    const transition = getTransition(state, containerSize);

    return {
      action: transition ? 'transition' : 'waiting',
      transition,
      offsetCoords: transition ? { x: 0, y: 0 } : state.offsetCoords,
    } as SliderState;
  };
}

export function touchEndSetState(containerSize?: IContainerSize) {
  return (state: SliderState) => {
    const currentSlide = getCurrentSlide(state);
    if (state.action !== 'move' || currentSlide.zoom <= 1 || !state.touchStartCoords || !state.currentTouchCoords) {
      return null;
    }

    const { offsetCoords } = state;

    return {
      offsetCoords: {
        x: offsetCoords.x + getXOffset(state),
        y: getYOffsetHanlder(state, containerSize),
      },
    };
  };
}

export function touchMoveSetState(coords: ICoords, preventXMovingFromProps?: boolean) {
  return (state: SliderState) => {
    if (state.action !== 'move') {
      return undefined;
    }

    const preventXMoving = preventXMovingFromProps || (state.slides.length <= 1 && getCurrentSlide(state).zoom === 1);

    const newState = {
      action: 'move',
      currentTouchCoords: preventXMoving ? { x: state.touchStartCoords.x, y: coords.y } : coords,
    };

    return newState as IMovingState;
  };
}
